import React, {FC} from 'react';
import {useTranslation} from 'gatsby-plugin-react-i18next';
import SignInForm from './SignInForm/SignInForm';
import Typography from 'design-system/src/Components/Typography/Typography.web';
import SocialNetworkAuthentication from '../SocialNetworkAuthentication/SocialNetworkAuthentication';
import useBreakpoint from 'design-system/src/WebComponent/Grid/hooks/useBreakpoint';
import {useI18next} from 'gatsby-plugin-react-i18next';
import {useAppDispatch} from '@src/Store/hooks';
import appAuthSlice from '@src/Store/Slices/AppSlice/auth.slice';
import {getAllowedAuthProviders} from '@src/Configs/authDomainConfig';

interface SignInProps {
  redirect?: string;
}

const containerStyle: React.CSSProperties = {
  width: '100%',
  maxWidth: 418,
  padding: '0 16px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  position: 'relative',
};

const signInLabelStyle = {
  textTransform: 'uppercase' as 'uppercase',
  marginBottom: 25,
};

const orLabelStyle = {marginBottom: 25, marginTop: 25};

const SignIn: FC<SignInProps> = ({redirect}) => {
  const {t} = useTranslation('auth');
  const {isMobile} = useBreakpoint();
  const {navigate} = useI18next();
  const dispatch = useAppDispatch();
  const allowedProviders = getAllowedAuthProviders();
  const showEmailAuth = allowedProviders.includes('email');

  const handleSuccess = () => {
    const shouldNavigate =
      typeof window !== 'undefined' &&
      !window.location.pathname.includes('/tv-auth') &&
      !window.location.pathname.includes('/subscription');

    if (shouldNavigate) {
      navigate(redirect || '/app', {
        replace: true,
      });
    }

    dispatch(appAuthSlice.actions.closeAuthModal());
  };

  return (
    <div style={containerStyle}>
      <Typography
        variant={isMobile ? 'body2' : 'formTitle'}
        style={signInLabelStyle}>
        {t('Sign in')}
      </Typography>

      <SocialNetworkAuthentication isSignIn={true} onSuccess={handleSuccess} />

      {showEmailAuth && (
        <>
          <Typography variant="body2" style={orLabelStyle}>
            {t('Or')}
          </Typography>
          <SignInForm onSuccess={handleSuccess} />
        </>
      )}
    </div>
  );
};

export default SignIn;
